import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useState} from 'react'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {Image, Input, Tabs} from "antd";
import {renderIf, renderIfElse} from "../../../Shared";
import _ from "lodash";
import Translate from "../../../../modules/local/Translate";
import {compose, mapProps, pure} from "recompose";
import withTranslate from "../../../../modules/local/withTranslate";
import {createControlledFormField} from "../../factory/createFormField";
import {baseFieldTypes} from "../../../../apis/base/baseFieldTypes";
import {Formik} from "formik";
import FormActionBar from "../../../../components/form/FormActionBar";
import {NullAsDefault, shallowDiff} from 'views/Shared'
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {GoDotFill} from "react-icons/go";
import {renderParishCascade} from "../../User/functions/renderParishCascade";
import SlateEditor, {SlateRenderer} from "../../../SlateEditor";
import {ModalEditorToolbar} from "../../../SlateEditor/SlateEditor";
import {convertFromString, convertToString} from "../../../SlateEditor/functions";
import {isRawContentEmpty} from "../../../SlateEditor/functions/parseRawContent";
import PhotoField from "../../custom/PhotoField";
import {BiSolidChurch} from "react-icons/bi";
import {DioceseTypeCodes} from "../../appFieldTypes";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {ItemInformation} from "../../../../components/common/ItemInformation";
import {LoginContext} from "../../../../components/LoginContext";
import {isSystemAdmin} from "../../../../helpers/authUtils";
import {ChipGroup, createSlateTab, Field, FormActions, Section} from "../../../../components/form/ModernForm";
import {
    IoBookOutline,
    IoBusinessOutline,
    IoCallOutline,
    IoDocumentTextOutline,
    IoEarthOutline,
    IoImageOutline,
    IoPeopleOutline,
    IoStatsChartOutline,
} from "react-icons/io5";

const formSchema = {
    photo: {
        title: 'avatar',
        children: [
            {
                name: 'photo',
                component: ({name, value, form, onChange}) => (
                    <LayoutContext.Consumer>
                        {({isSm}) => (
                            <Translate>
                                {(t) => (
                                    <div className="flex flex-col gap-1">
                                        <span
                                            className="text-xs text-color-500 italic">{`* ${t('description size avatar')}`}</span>
                                        <PhotoField
                                            Wrapper={({children}) => (
                                                <div className="flex flex-col flex-center relative">
                                                    {children}
                                                </div>
                                            )}
                                            className="background"
                                            cropPurpose="avatar"
                                            cropShape="rect"
                                            square
                                            style={{
                                                padding: 0,
                                                minWidth: isSm ? 140 : 180,
                                                minHeight: isSm ? 140 : 180,
                                                maxWidth: isSm ? 140 : 180,
                                                maxHeight: isSm ? 140 : 180,
                                            }}
                                            values={_.get(form, 'values')}
                                            {...{name, value, onChange}}
                                        />
                                    </div>
                                )}
                            </Translate>
                        )}
                    </LayoutContext.Consumer>
                ),
            },
        ],
    },
    fullname: {
        title: 'name of diocese',
        children: [
            {
                name: 'fullname',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate, form}) => ({
                        name,
                        value,
                        onChange,
                        type: 'text',
                        placeholder: translate('input name of diocese'),
                    })),
                    pure
                )(Input),
            },
        ]
    },
    church_parent: {
        children: [
            {
                label: 'belong to the archdiocese',
                name: 'church_parent',
                component: ({form, name, value, onChange}) =>
                    renderParishCascade({
                        name,
                        value,
                        onChange,
                        country_id: 237,
                    }),
            },
        ],
    },

    continent_rite: {
        children: [
            {
                label: 'continent',
                name: 'continent',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate, form}) => ({
                        name,
                        value,
                        onChange,
                        type: 'text',
                        placeholder: translate('continent'),
                    })),
                    pure
                )(Input),
            },
            {
                label: 'rite',
                name: 'rite',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate, form}) => ({
                        name,
                        value,
                        onChange,
                        type: 'text',
                        placeholder: translate('rite'),
                    })),
                    pure
                )(Input),
            },
        ],
    },
    contact_phone_name: {
        children: [
            {
                label: 'contact name',
                name: 'contact_name',
                component: createControlledFormField({
                    placeholder: 'ex: pastor name',
                    Component: Input,
                }),
            },
            {
                label: 'phone',
                name: 'contact_phone',
                component: createControlledFormField({
                    type: 'tel',
                    placeholder: 'ex: phone',
                    Component: Input,
                }),
            },
        ],
    },
    address: {
        title: 'address',
        children: [
            {
                name: 'contact_address',
                component: ({onChange, value}) => (
                    <Translate>
                        {(t) => (
                            <div className="flex flex-col gap-1">
                                <Input
                                    name="contact_address"
                                    value={value}
                                    onChange={onChange}
                                    placeholder={t('ex: address')}
                                />
                                <span className="text-xs text-color-500 italic">
                    {`* ${t('contact address diocese description')}`}
                </span>
                            </div>
                        )}
                    </Translate>
                ),
            },
        ],
    },
    about: {
        title: 'introduce',
        children: [
            {
                name: 'about',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    history: {
        title: 'history diocese',
        children: [
            {
                name: 'history',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    bishops: {
        title: 'bishops',
        children: [
            {
                name: 'bishops',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    churches: {
        title: 'deanery - parish',
        children: [
            {
                name: 'churches',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    statistics: {
        title: 'other information',
        children: [
            {
                name: 'statistics',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
}

// Tái dùng thẳng các component field đã có sẵn trong formSchema (PhotoField, cascade Tổng giáo
// phận, SlateEditor...) thay vì viết lại - chỉ đổi khung ngoài (Section/Field) cho Create/
// EditDioceseForm, cùng pattern đã dùng ở ProfileForm.js/ParishForm.js.
const PhotoInput = formSchema.photo.children[0].component
const FullnameInput = formSchema.fullname.children[0].component
const ChurchParentInput = formSchema.church_parent.children[0].component
const ContinentInput = formSchema.continent_rite.children[0].component
const RiteInput = formSchema.continent_rite.children[1].component
const ContactNameInput = formSchema.contact_phone_name.children[0].component
const ContactPhoneInput = formSchema.contact_phone_name.children[1].component
const AddressInput = formSchema.address.children[0].component
const AboutInput = formSchema.about.children[0].component
const HistoryInput = formSchema.history.children[0].component
const BishopsInput = formSchema.bishops.children[0].component
const ChurchesInput = formSchema.churches.children[0].component
const StatisticsInput = formSchema.statistics.children[0].component

const useIsSuperAdmin = () => {
    const login = useContext(LoginContext)
    return isSystemAdmin(login)
}

// Placeholder chuẩn khi 1 khối dữ liệu (Giám mục / Giáo hạt & Xứ / Lịch...) chưa có nội dung.
// Nút "+ Bổ sung thông tin" chỉ hiện với super admin (theo yêu cầu), người dùng khác chỉ thấy mô tả.
const EmptyBlock = ({title, description, onAdd}) => {
    const t = useTranslate()
    const isAdmin = useIsSuperAdmin()
    return (
        <div
            className="p-4 border border-dashed border-color-100 rounded-lg flex flex-col flex-center gap-1 text-center">
            <span className="font-semibold text-sm text-color-200">{t(title)}</span>
            <span className="text-xs text-color-500 italic leading-snug">{t(description)}</span>
            {renderIf(
                isAdmin && onAdd,
                <span
                    onClick={onAdd}
                    className="mt-2 font-medium text-xs text-blue-500 hover:text-blue-600 cursor-pointer tracking-wide">
                    {`+ ${t('add information')}`}
                </span>
            )}
        </div>
    )
}

const OverviewTab = ({item, onEdit}) => {
    const t = useTranslate()
    const {
        archdiocese,
        contact_address,
        contact_name,
        contact_phone,
        description,
        about,
        statistics,
        websites = [],
        diocese_typecd,
        continent,
        rite,
        bishops,
    } = item ?? {}

    const diocese_type = _.find(DioceseTypeCodes, {value: diocese_typecd})?.label
    const hasContact = !!contact_name || !!contact_phone || !!contact_address

    return (
        <div className="flex flex-col gap-2">
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <GoDotFill size={14} className="text-color-500"/>
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                        {t('diocese information')}
                    </span>
                    </div>
                )}
            />
            <div className="ml-5 flex flex-col gap-2">
                <ItemInformation label="type" value={t(diocese_type)} className="text-sm"/>
                {renderIf(
                    continent,
                    <ItemInformation label="continent" value={continent} className="text-sm"/>
                )}
                {renderIf(
                    rite,
                    <ItemInformation label="rite" value={rite} className="text-sm"/>
                )}
                {renderIf(
                    archdiocese,
                    <ItemInformation label="belong to the archdiocese" value={archdiocese?.fullname}
                                     className="text-sm"/>
                )}
                {renderIf(
                    websites.length > 0,
                    websites.map((e, i) => !!e?.url && (
                        <div key={i} className="flex-1 items-baseline gap-1">
                            <span className="text-color-500 italic">{`${e?.page} : `}</span>
                            <a href={e?.url} target="_blank"
                               className="font-medium text-sm text-color-100 hover:text-primary-500 no-underline">
                                {e?.url}
                            </a>
                        </div>
                    ))
                )}
                {renderIf(
                    description,
                    <div className="text-sm text-color-400">
                        {description}
                    </div>
                )}
            </div>

            <HeaderWithIconLine
                className="mt-3"
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <GoDotFill size={14} className="text-color-500"/>
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                      {t('bishop')}
                </span>
                    </div>
                )}
            />
            <div className="ml-5">
                {renderIfElse(
                    !isRawContentEmpty(bishops),
                    <span className="text-sm text-color-400 italic">{t('see bishop tab for details')}</span>,
                    <EmptyBlock
                        title="leadership not updated"
                        description="bishop see not yet appointed or synced"
                        onAdd={onEdit}
                    />
                )}
            </div>

            <HeaderWithIconLine
                className="mt-3"
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <GoDotFill size={14} className="text-color-500"/>
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                      {t('contact information')}
                </span>
                    </div>
                )}
            />
            <div className="ml-5">
                {renderIfElse(
                    hasContact,
                    <div className="flex flex-col gap-2">
                        {renderIfElse(
                            contact_name,
                            <ItemInformation label="contact name" value={contact_name} className="text-sm"/>,
                            <ItemInformation label="contact name" value={t('not yet updated')}
                                             className="text-sm text-color-500 italic"/>
                        )}
                        {renderIfElse(
                            contact_phone,
                            <ItemInformation label="phone" value={contact_phone} className="text-sm"/>,
                            <ItemInformation label="phone" value={t('not yet updated')}
                                             className="text-sm text-color-500 italic"/>
                        )}
                        {renderIfElse(
                            contact_address,
                            <ItemInformation label="address" value={contact_address} className="text-sm"/>,
                            <ItemInformation label="address" value={t('not yet updated')}
                                             className="text-sm text-color-500 italic"/>
                        )}
                    </div>,
                    <EmptyBlock
                        title="contact information"
                        description="contact information not updated"
                        onAdd={onEdit}
                    />
                )}
            </div>

            {renderIf(
                !isRawContentEmpty(about),
                <>
                    <HeaderWithIconLine
                        className="mt-3"
                        renderTitle={() => (
                            <div className="flex items-center gap-2">
                                <GoDotFill size={14} className="text-color-500"/>
                                <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                        {t('about diocese')}
                    </span>
                            </div>
                        )}
                    />
                    <div style={{fontSize: 13}} className="ml-5">
                        <SlateRenderer value={convertFromString(about)}/>
                    </div>
                </>
            )}

            {renderIf(
                !isRawContentEmpty(statistics),
                <>
                    <HeaderWithIconLine
                        className="mt-3"
                        renderTitle={() => (
                            <div className="flex items-center gap-2">
                                <GoDotFill size={14} className="text-color-500"/>
                                <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                        {t('other information')}
                    </span>
                            </div>
                        )}
                    />
                    <div style={{fontSize: 13}} className="ml-5">
                        <SlateRenderer value={convertFromString(statistics)}/>
                    </div>
                </>
            )}
        </div>
    )
}

const BishopsDiocese = ({item, onEdit}) => {
    const t = useTranslate()
    return (
        <div className="flex flex-col">
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <GoDotFill size={14} className="text-color-500"/>
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                        {t('bishops')}
                    </span>
                    </div>
                )}
            />
            {renderIfElse(
                !isRawContentEmpty(item),
                <div style={{fontSize: 13}} className="ml-3">
                    <SlateRenderer value={convertFromString(item)}/>
                </div>,
                <EmptyBlock
                    title="no bishop data"
                    description="bishop hierarchy not digitized"
                    onAdd={onEdit}
                />
            )}
        </div>
    )
}

const ListOfParish = ({item, onEdit}) => {
    const t = useTranslate()
    return (
        <div className="flex flex-col">
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <GoDotFill size={14} className="text-color-500"/>
                        <div className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                            {t('list of deanery parish')}
                        </div>
                    </div>
                )}
            />
            {renderIfElse(
                !isRawContentEmpty(item),
                <div style={{fontSize: 13}} className="ml-3">
                    <SlateRenderer value={convertFromString(item)}/>
                </div>,
                <EmptyBlock
                    title="deanery - parish"
                    description="deanery parish list not updated"
                    onAdd={onEdit}
                />
            )}
        </div>
    )
}

const HistoryOfEstablishment = ({item, onEdit}) => {
    const t = useTranslate()

    return (
        <div className="flex flex-col">
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <GoDotFill size={14} className="text-color-500"/>
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                        {t('history')}
                    </span>
                    </div>
                )}
            />
            {renderIfElse(
                !isRawContentEmpty(item),
                <div style={{fontSize: 13}} className="ml-3">
                    <SlateRenderer value={convertFromString(item)}/>
                </div>,
                <EmptyBlock
                    title="history"
                    description="history data being compiled"
                    onAdd={onEdit}
                />
            )}
        </div>
    )
}

export const DetailViewForm = ({item, onCancel, onEdit}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [current, setCurrent] = useState('overview')
    const {
        photo,
        archdiocese,
        fullname,
        churches,
        history,
        bishops,
        diocese_typecd,
    } = item ?? {}

    const diocese_type = _.find(DioceseTypeCodes, {value: diocese_typecd})?.label

    const tabs = [
        {
            key: 'overview',
            label: 'overview',
            content: <OverviewTab item={item} onEdit={onEdit}/>,
        },
        {
            key: 'bishop',
            label: 'bishop',
            content: <BishopsDiocese item={bishops} onEdit={onEdit}/>,
        },
        {
            key: 'deanery',
            label: 'deanery - parish',
            content: <ListOfParish item={churches} onEdit={onEdit}/>,
        },
        {
            key: 'history',
            label: 'history',
            content: <HistoryOfEstablishment item={history} onEdit={onEdit}/>,
        },
    ]

    return (
        <div className="flex flex-col gap-3">

            <div className="relative overflow-hidden -mx-4 -mt-4" style={{height: isSm ? 170 : 210}}>
                {renderIfElse(
                    photo,
                    <Image
                        src={photo}
                        className="w-full h-full object-cover"
                        wrapperStyle={{width: '100%', height: '100%'}}
                        preview={true}
                    />,
                    <div
                        className="w-full h-full flex flex-center"
                        style={{background: 'linear-gradient(135deg, #d97706 0%, #7c2d12 100%)'}}>
                        <BiSolidChurch size={64} style={{color: '#fff', opacity: 0.2}}/>
                    </div>
                )}
                <div
                    className="absolute inset-x-0 bottom-0 pointer-events-none"
                    style={{
                        height: '75%',
                        background: 'linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0) 100%)',
                    }}
                />
                <div className="absolute inset-x-0 bottom-0 p-3 flex flex-col gap-1">
                    <span
                        className="w-fit px-2 py-0.5 flex items-center gap-1 text-white font-bold text-2xs uppercase rounded-full tracking-wider"
                        style={{background: '#d97706'}}>
                        <BiSolidChurch size={12}/>
                        {t(diocese_type ?? 'diocese')}
                    </span>
                    <span className="font-bold text-lg md:text-xl text-white uppercase tracking-wide truncate leading-tight">
                        {fullname}
                    </span>
                    {renderIf(
                        archdiocese,
                        <span className="text-xs text-white text-opacity-80 truncate">
                            {`${t('belong to the archdiocese')}: ${archdiocese?.fullname}`}
                        </span>
                    )}
                </div>
            </div>

            <Tabs
                centered
                size="small"
                activeKey={current}
                onChange={setCurrent}
                className="custom-tabs-menu"
                items={tabs.map((e) => ({
                    key: e.key,
                    label: <span className="font-medium text-sm">{t(e.label)}</span>,
                    children: e.content,
                }))}
            />

        </div>
    )
}

export const CreateDioceseForm = ({
                                      onCancel = NullAsDefault,
                                      onSubmit = NullAsDefault,
                                  }) => {
    const t = useTranslate()

    const validate = (values) => {
        let errors = {}
        if (_.isEmpty(_.get(values, 'fullname') ?? undefined)) {
            errors.fullname = t('required field')
        }
        return errors
    }
    const initialValues = {
        fullname: undefined,
        diocese_typecd: DioceseTypeCodes.DIOCESE.value,
    }

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={(values) => {
                const changes = shallowDiff(values, initialValues)
                onSubmit(_.omitBy({...changes}, _.isUndefined))
            }}>
            {(formik) => {
                const {values, touched, errors, setFieldValue, handleSubmit, isSubmitting, isValid} = formik
                const onChange = (e) => setFieldValue(e.target.name, e.target.value)

                return (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <Section icon={IoBusinessOutline} title={t('name of diocese')} theme="highlight">
                            <Field label={t('type')}>
                                <ChipGroup
                                    options={Object.values(DioceseTypeCodes)}
                                    value={values.diocese_typecd}
                                    onChange={(v) => setFieldValue('diocese_typecd', v)}
                                />
                            </Field>
                            <Field label={t('name of diocese')} required error={touched.fullname && errors.fullname}>
                                <FullnameInput name="fullname" value={values.fullname} onChange={onChange}/>
                            </Field>
                        </Section>

                        <Section icon={IoCallOutline} title={t('contact information')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('contact name')}>
                                    <ContactNameInput name="contact_name" value={values.contact_name} onChange={onChange}/>
                                </Field>
                                <Field label={t('phone')}>
                                    <ContactPhoneInput name="contact_phone" value={values.contact_phone} onChange={onChange}/>
                                </Field>
                            </div>
                            <Field label={t('address')}>
                                <AddressInput value={values.contact_address} onChange={onChange}/>
                            </Field>
                        </Section>

                        <Section icon={IoStatsChartOutline} title={t('status')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('active')}>
                                    <ChipGroup
                                        options={baseFieldTypes.active}
                                        value={values.active}
                                        onChange={(v) => setFieldValue('active', v)}
                                    />
                                </Field>
                                <Field label={t('error status')}>
                                    <ChipGroup
                                        options={baseFieldTypes.error_status}
                                        value={values.error_status}
                                        onChange={(v) => setFieldValue('error_status', v)}
                                    />
                                </Field>
                            </div>
                        </Section>

                        <FormActions onCancel={onCancel} submitText="create" isSubmitting={isSubmitting} isValid={isValid}/>
                    </form>
                )
            }}
        </Formik>
    )
}

const DioceseEditAboutTab = createSlateTab('about', AboutInput, IoBookOutline, 'introduce')
const DioceseEditHistoryTab = createSlateTab('history', HistoryInput, IoDocumentTextOutline, 'history diocese')
const DioceseEditBishopTab = createSlateTab('bishops', BishopsInput, IoPeopleOutline, 'bishops')
const DioceseEditChurchTab = createSlateTab('churches', ChurchesInput, IoBusinessOutline, 'deanery - parish')
const DioceseEditStatisticsTab = createSlateTab('statistics', StatisticsInput, IoStatsChartOutline, 'other information')
const DioceseEditOverviewTab = ({child}) => child

export const EditDioceseForm = ({
                                    item,
                                    initialValues,
                                    onCancel = NullAsDefault,
                                    onSubmit = NullAsDefault,
                                }) => {
    const t = useTranslate()
    const [current, setCurrent] = useState('overview')

    const archdiocese_id = _.get(initialValues, 'archdiocese_id')
    const _church_parent = []
    const isArchdiocese = _.get(initialValues, 'diocese_typecd') === DioceseTypeCodes.ARCHDIOCESE.value

    if (Boolean(archdiocese_id)) _church_parent.push(archdiocese_id)

    const _initialValues = {
        photo: _.get(initialValues, 'photo', ''),
        fullname: _.get(initialValues, 'fullname', ''),
        diocese_typecd: _.get(initialValues, 'diocese_typecd', DioceseTypeCodes.DIOCESE.value),
        church_parent: _church_parent,
        continent: _.get(initialValues, 'continent'),
        rite: _.get(initialValues, 'rite'),
        active: _.get(initialValues, 'active', 0),
        error_status: _.get(initialValues, 'error_status', 0),
        contact_phone: _.get(initialValues, 'contact_phone', ''),
        contact_name: _.get(initialValues, 'contact_name', ''),
        contact_address: _.get(initialValues, 'contact_address', ''),
        about: convertFromString(_.get(initialValues, 'about')),
        history: convertFromString(_.get(initialValues, 'history')),
        bishops: convertFromString(_.get(initialValues, 'bishops')),
        churches: convertFromString(_.get(initialValues, 'churches')),
        statistics: convertFromString(_.get(initialValues, 'statistics')),
    }

    const validate = (values) => {
        let errors = {}
        if (_.isEmpty(_.get(values, 'fullname') ?? undefined)) {
            errors.fullname = t('required field')
        }
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={({about, history, bishops, churches, statistics, ...values}) => {
                const changes = shallowDiff(values, _initialValues)
                onSubmit(_.omitBy({
                    ...changes,
                    about: about ? convertToString(about) : undefined,
                    history: history ? convertToString(history) : undefined,
                    bishops: bishops ? convertToString(bishops) : undefined,
                    churches: churches ? convertToString(churches) : undefined,
                    statistics: statistics ? convertToString(statistics) : undefined,
                }, _.isUndefined))
            }}>
            {(formik) => {
                const {values, touched, errors, setFieldValue} = formik
                const onChange = (e) => setFieldValue(e.target.name, e.target.value)

                const overviewContent = (
                    <div className="flex flex-col gap-4">
                        <Section icon={IoImageOutline} title={t('avatar')} subtitle={t('optional')}>
                            <PhotoInput name="photo" value={values.photo} form={formik} onChange={onChange}/>
                        </Section>

                        <Section icon={IoBusinessOutline} title={t('name of diocese')} theme="highlight">
                            <Field label={t('type')}>
                                <ChipGroup
                                    options={Object.values(DioceseTypeCodes)}
                                    value={values.diocese_typecd}
                                    onChange={(v) => setFieldValue('diocese_typecd', v)}
                                />
                            </Field>
                            <Field label={t('name of diocese')} required error={touched.fullname && errors.fullname}>
                                <FullnameInput name="fullname" value={values.fullname} onChange={onChange}/>
                            </Field>
                        </Section>

                        {!isArchdiocese && (
                            <Section icon={IoEarthOutline} title={t('belong to the archdiocese')} subtitle={t('optional')}>
                                <ChurchParentInput name="church_parent" value={values.church_parent} onChange={onChange}/>
                            </Section>
                        )}

                        <Section icon={IoEarthOutline} title={t('continent')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('continent')}>
                                    <ContinentInput name="continent" value={values.continent} onChange={onChange}/>
                                </Field>
                                <Field label={t('rite')}>
                                    <RiteInput name="rite" value={values.rite} onChange={onChange}/>
                                </Field>
                            </div>
                        </Section>

                        <Section icon={IoCallOutline} title={t('contact information')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('contact name')}>
                                    <ContactNameInput name="contact_name" value={values.contact_name} onChange={onChange}/>
                                </Field>
                                <Field label={t('phone')}>
                                    <ContactPhoneInput name="contact_phone" value={values.contact_phone} onChange={onChange}/>
                                </Field>
                            </div>
                            <Field label={t('address')}>
                                <AddressInput value={values.contact_address} onChange={onChange}/>
                            </Field>
                        </Section>

                        <Section icon={IoStatsChartOutline} title={t('status')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('active')}>
                                    <ChipGroup
                                        options={baseFieldTypes.active}
                                        value={values.active}
                                        onChange={(v) => setFieldValue('active', v)}
                                    />
                                </Field>
                                <Field label={t('error status')}>
                                    <ChipGroup
                                        options={baseFieldTypes.error_status}
                                        value={values.error_status}
                                        onChange={(v) => setFieldValue('error_status', v)}
                                    />
                                </Field>
                            </div>
                        </Section>
                    </div>
                )

                return (
                    <ActionModalWrapper
                        tab={current}
                        action={<FormActionBar submitText="save"/>}
                        onTabChange={(key) => setCurrent(key)}
                        tabs={[
                            {key: 'overview', label: 'overview', component: DioceseEditOverviewTab},
                            {key: 'about', label: 'about diocese', component: DioceseEditAboutTab},
                            {key: 'history', label: 'history diocese', component: DioceseEditHistoryTab},
                            {key: 'bishop', label: 'bishops', component: DioceseEditBishopTab},
                            {key: 'church', label: 'deanery - parish', component: DioceseEditChurchTab},
                            {key: 'statistics', label: 'other information', component: DioceseEditStatisticsTab},
                        ]}>
                        {overviewContent}
                    </ActionModalWrapper>
                )
            }}
        </Formik>
    )
}